export const countries = ['IN', 'US'];
export const countryCodes = { IN: '+91', US: '+1' };
